import { OrderType } from "../types/AppTypes";

export const sortData = <T>(data: T[], property: string, order: OrderType) => {
  return data.slice().sort((a, b) => {
    if (order === 'asc') {
      if (a[property] < b[property]) return -1;
      if (a[property] > b[property]) return 1;
      return 0;
    } else {
      if (a[property] > b[property]) return -1;
      if (a[property] < b[property]) return 1;
      return 0;
    }
  });
};
